import styled from '@emotion/styled';
import { colors, Text } from '@innovationdepartment/proxima-ui';

import { Info } from '@mui/icons-material';
import { useEffect, useRef } from 'react';

const Container = styled.div`
  background-color: white;
  min-height: 200px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

const TestContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  & svg {
    fill: ${colors.neutral20};
  }
`;

const BrandProductsEmptyState = ({ loading }: { loading: boolean }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      // sets table row background to white
      ref.current.closest('tr')?.style.setProperty('background', 'white');
    }
  }, []);

  return (
    <Container ref={ref}>
      <TestContainer>
        <Info />
        <Text variant="h5" isTermina={false} color="neutral20">
          {loading ? 'Fetching products...' : 'No products found for this brand'}
        </Text>
      </TestContainer>
    </Container>
  );
};

export default BrandProductsEmptyState;
